import React from 'react';
import { Video } from 'abbot-core';
import videoFile from '../../assets/videos/U1-T2-2-1.mp4';
import captions from '../../assets/videos/U1-T2-2-1.vtt';
import poster from '../../assets/videos/U1-T2-2-1.png';

const video = {
  sources: [
    {
      src: videoFile
    }
  ],
  tracks: [
    {
      src: captions,
      kind: 'captions',
      label: 'English'
    }
  ],
  poster
};

export default {
  title: 'Nutritious Eating and Your Body',
  path: '/learn/nutritious-eating-and-your-body',
  content: <Video videoFiles={video} />
};



// WEBPACK FOOTER //
// ./src/data/learn/NutritiousEatingAndYourBody.js